import { render, staticRenderFns } from "./QuestionFileNew.vue?vue&type=template&id=06dbbdf0"
import script from "./QuestionFileNew.vue?vue&type=script&lang=js"
export * from "./QuestionFileNew.vue?vue&type=script&lang=js"
import style0 from "./QuestionFileNew.vue?vue&type=style&index=0&id=06dbbdf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports